import {Divider, Modal} from 'antd';
import React, {ReactNode} from 'react';

import {drawerZIndex} from '../../constants/Common';

const DisplayModal: React.FC<{
  title: string;
  open: boolean;
  onCancel: () => void;
  displayComponent: ReactNode;
  isTable?: boolean;
}> = ({title, open, onCancel, displayComponent, isTable}) => {
  return (
    <Modal
      title={title}
      open={open}
      centered
      className="displayModal"
      onCancel={onCancel}
      okButtonProps={{
        style: {display: 'none'}
      }}
      cancelButtonProps={{
        style: {display: 'none'}
      }}
      style={{
        minWidth: '30%'
      }}
      width={isTable ? '70%' : 'fit-content'}
      zIndex={drawerZIndex}
    >
      <>
        <Divider />
        {displayComponent}
      </>
    </Modal>
  );
};

export default DisplayModal;
